import React from 'react';
import { Image } from '../../wag-react/core-components/image';
import { Box } from '../Box';
import { Flex } from '../Flex';
import { ImagePreview, Props as ImagePreviewProps, ImagePreviewFile } from '../ImagePreview';
import removeIcon from './assets/remove-icon.svg';
type Props = Omit<ImagePreviewProps, 'value'> & {
  value: ImagePreviewFile[];
  onRemove?: (index: number) => void;
};
export const ImagePreviews = ({
  value,
  onRemove,
  ...rest
}: Props) => <Flex display={value && value.length ? 'flex' : 'none'} flexDirection={['column', 'row']} flexWrap="wrap" margin="-4px" width={1} height="100%" data-sentry-element="Flex" data-sentry-component="ImagePreviews" data-sentry-source-file="index.tsx">
    {value.map((imagePreview, index) => <Box key={imagePreview.name} position="relative" padding="4px" width={[1, '320px']} height="216px">
        <Box hover height="40px" width="40px" position="absolute" right="0" top="0">
          <Image hover src={removeIcon} alt="remove-icon" onClick={() => onRemove ? onRemove(index) : undefined} />
        </Box>
        <ImagePreview value={imagePreview} borderRadius="8px" width="100%" height="100%" {...rest} />
      </Box>)}
  </Flex>;